var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnfoldedFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{display:inline;}\r\n\t.st2{opacity:0.3;fill:none;stroke:#4698CA;enable-background:new    ;}\r\n\t.st3{fill:none;stroke:#4698CA;}\r\n\t.st4{opacity:0.3;fill:none;stroke:#4698CA;stroke-width:4.687500e-02;enable-background:new    ;}\r\n\t.st5{fill:none;stroke:#4698CA;stroke-width:4.687500e-02;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{fill:none;}\r\n\t.st9{fill:#020301;}\r\n\t.st10{clip-path:url(#SVGID_2_);}\r\n\t.st11{clip-path:url(#SVGID_4_);}\r\n\t.st12{clip-path:url(#SVGID_6_);}\r\n\t.st13{fill-rule:evenodd;clip-rule:evenodd;fill:#00CCB3;}\r\n\t.st14{clip-path:url(#SVGID_8_);fill:#FFFFFF;}\r\n\t.st15{fill-rule:evenodd;clip-rule:evenodd;fill:#32AFFF;}\r\n\t.st16{clip-path:url(#SVGID_10_);fill:#FFFFFF;}\r\n\t.st17{fill:none;stroke:#000000;stroke-width:19;stroke-miterlimit:10;}\r\n\t.st18{fill:none;stroke:#000000;stroke-width:19;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t\r\n\t\t.st19{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:10;stroke-dasharray:20,30;}\r\n\t\r\n\t\t.st20{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:square;stroke-linejoin:bevel;stroke-miterlimit:10;stroke-dasharray:5,30;}\r\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:13;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "grid",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0.9,
    y1: 0,
    x2: 0.9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 1.4,
    y1: 0,
    x2: 1.4,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 1.9,
    y1: 0,
    x2: 1.9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 2.3,
    y1: 0,
    x2: 2.3,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 2.8,
    y1: 0,
    x2: 2.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 3.3,
    y1: 0,
    x2: 3.3,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 3.8,
    y1: 0,
    x2: 3.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 4.2,
    y1: 0,
    x2: 4.2,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 4.7,
    y1: 0,
    x2: 4.7,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 5.2,
    y1: 0,
    x2: 5.2,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 5.6,
    y1: 0,
    x2: 5.6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 6.1,
    y1: 0,
    x2: 6.1,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 6.6,
    y1: 0,
    x2: 6.6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 7,
    y1: 0,
    x2: 7,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 7.5,
    y1: 0,
    x2: 7.5,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 8,
    y1: 0,
    x2: 8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 8.4,
    y1: 0,
    x2: 8.4,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 8.9,
    y1: 0,
    x2: 8.9,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 9.4,
    y1: 0,
    x2: 9.4,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 9.8,
    y1: 0,
    x2: 9.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 10.3,
    y1: 0,
    x2: 10.3,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 10.8,
    y1: 0,
    x2: 10.8,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 11.2,
    y1: 0,
    x2: 11.2,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 11.7,
    y1: 0,
    x2: 11.7,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 12.2,
    y1: 0,
    x2: 12.2,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 12.7,
    y1: 0,
    x2: 12.7,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 13.1,
    y1: 0,
    x2: 13.1,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 13.6,
    y1: 0,
    x2: 13.6,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 14.1,
    y1: 0,
    x2: 14.1,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 14.5,
    y1: 0,
    x2: 14.5,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 0.5,
    x2: 15,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 0.9,
    x2: 15,
    y2: 0.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 1.4,
    x2: 15,
    y2: 1.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 1.9,
    x2: 15,
    y2: 1.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 2.3,
    x2: 15,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 2.8,
    x2: 15,
    y2: 2.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 3.3,
    x2: 15,
    y2: 3.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 3.8,
    x2: 15,
    y2: 3.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 4.2,
    x2: 15,
    y2: 4.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 4.7,
    x2: 15,
    y2: 4.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 5.2,
    x2: 15,
    y2: 5.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 5.6,
    x2: 15,
    y2: 5.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 6.1,
    x2: 15,
    y2: 6.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 6.6,
    x2: 15,
    y2: 6.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 7,
    x2: 15,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 7.5,
    x2: 15,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 8,
    x2: 15,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 8.4,
    x2: 15,
    y2: 8.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 8.9,
    x2: 15,
    y2: 8.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 9.4,
    x2: 15,
    y2: 9.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 9.8,
    x2: 15,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 10.3,
    x2: 15,
    y2: 10.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 10.8,
    x2: 15,
    y2: 10.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 11.2,
    x2: 15,
    y2: 11.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 11.7,
    x2: 15,
    y2: 11.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 12.2,
    x2: 15,
    y2: 12.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 12.7,
    x2: 15,
    y2: 12.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 13.1,
    x2: 15,
    y2: 13.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 13.6,
    x2: 15,
    y2: 13.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 0,
    y1: 14.1,
    x2: 15,
    y2: 14.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 0,
    y1: 14.5,
    x2: 15,
    y2: 14.5
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.7,4.7h9c-0.1-0.6-0.6-1.1-1.3-1.1H7.7C7.3,3.5,7,3.4,6.7,3.1L6.2,2.6C5.9,2.4,5.6,2.2,5.2,2.2H1.8 c-0.7,0-1.3,0.6-1.3,1.3l0,7.9c0,0.7,0.5,1.3,1.2,1.3l1.2-6.7C3.1,5.3,3.8,4.7,4.7,4.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4,5.7c-0.1-0.1-0.3-0.2-0.5-0.2h-0.2h-9c-0.4,0-0.9,0.3-1,0.8l-1.2,6.5h9.9c0.4,0,0.9-0.3,1-0.8l0.2-1.2l0.9-4.7 C14.5,6,14.5,5.8,14.4,5.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnfoldedFolder);
export default __webpack_public_path__ + "static/media/Icon_Unfolded_Folder.2099b7babf3656beeeac859300e534b8.svg";
export { ForwardRef as ReactComponent };